module.exports = __webpack_public_path__ + "img/16.7bb29dd6.png";